import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';

import { PedidoNaoLiberadoCardInfoBonificacaoExcedenteComponent } from './pedido-nao-liberado-card-info-bonificacao-excedente.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule
    ],
    declarations: [
        PedidoNaoLiberadoCardInfoBonificacaoExcedenteComponent
    ],
    exports: [
        PedidoNaoLiberadoCardInfoBonificacaoExcedenteComponent
    ]
})
export class PedidoNaoLiberadoCardInfoBonificacaoExcedenteModule { }
